import script from "./TextEssay.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextEssay.vue?vue&type=script&lang=ts&setup=true"

import "./TextEssay.vue?vue&type=style&index=0&id=c6653758&lang=less"

const __exports__ = script;

export default __exports__